export default "__VITE_ASSET__BpHVgLyu__"